import React from "react";
import {
  Box,
  Typography,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";

type NumberRatingProps = {
  question: any;
  value?: number;
  onChange?: (val: number) => void;
};

const options = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
];

export default function NumberRating({
  question,
  value,
  onChange,
}: NumberRatingProps) {
  return (
    <Box sx={{ my: 2 }}>
      <ToggleButtonGroup
        exclusive
        value={value ?? ""}
        onChange={(_e, val) => {
          if (val !== null && onChange) onChange(val);
        }}
        sx={{ display: "flex", gap: 2 }}
      >
        {options.map((opt) => (
          <ToggleButton
            key={opt.value}
            value={opt.value}
            sx={{
              width: 42,
              height: 28,
              fontSize: 16,
              borderRadius: 2,
              borderColor: "#ececec",
              bgcolor: "#f5f5f5",
              "&.Mui-selected": {
                bgcolor: "#1976d2",
                color: "#fff",
                borderColor: "#1976d2",
                "&:hover": {
                  bgcolor: "#115293",
                },
              },
            }}
          >
            {opt.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
}
